/* eslint-disable jira/filename-case */
import type { FC, ComponentType } from 'react';
import type { useNotificationSettingsService } from '@jira/project-settings__notifications-services/src/NotificationSettingsContainer.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { WithIntlProps, IntlShape } from '@atlassian/jira-intl';
import type InternalNotificationSettingsPageType from './ExportedComponent.tsx';
import type { Props } from './NotificationInternalSettingsPage.tsx';

export const LazyInternalNotificationSettingsPage: LazyComponent<
	FC<
		WithIntlProps<
			Omit<
				Omit<
					Props & {
						useNotificationSettingsService: typeof useNotificationSettingsService;
						intl: IntlShape;
					},
					never
				> &
					Partial<unknown>,
				'useNotificationSettingsService'
			>
		>
	> & {
		WrappedComponent: ComponentType<
			Omit<
				Omit<
					Props & {
						useNotificationSettingsService: typeof useNotificationSettingsService;
						intl: IntlShape;
					},
					never
				> &
					Partial<unknown>,
				'useNotificationSettingsService'
			>
		>;
	}
> = lazyForPaint<typeof InternalNotificationSettingsPageType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-notification-internal-settings-page" */ './ExportedComponent.tsx'
		),
);
